<template>
  <!-- Content Wrapper. Contains page content -->
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->

    <!-- /.content-header -->

    <!-- Main content -->
    <section class="content">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-header">
                <h3 class="card-title">جدول صفحات</h3>
                <div class="card-tools">
                  <div class="input-group input-group-sm insert_box">
                    <b-form-input
                      v-model="searchName"
                      placeholder="جستوجوی نام صفحه"
                    ></b-form-input>
                    <button @click="showPostModal1()" class="btn btn-success">
                      افزودن
                    </button>
                  </div>
                </div>
              </div>
              <template v-if="!status">
                <div v-if="Items" class="card-body table-responsive p-0">
                  <table class="table table-hover">
                    <tr>
                      <th>
                        عنوان
                      </th>
                      <th>آدرس</th>
                      <th>وضعیت</th>
                      <th>تنظیمات</th>
                    </tr>
                    <template v-if="Items.length > 0">
                      <tr v-for="item in Items" :key="item.id">
                        <template v-for="(header, index) in headers">
                          <td
                            v-if="
                              header.type != 'setting' &&
                                header.show_in_tabel == true
                            "
                            :key="index + 20"
                          >
                            <span v-if="header.type == 'string'">{{
                              item[header.key]
                            }}</span>

                            <span
                              v-if="header.type == 'boolean'"
                              class="badge"
                              :class="{
                                'badge-success': item[header.key] == 1,
                                'badge-warning': item[header.key] == 0
                              }"
                            >
                              {{ item[header.key] == 1 ? "فعال" : "غیرفعال" }}
                            </span>

                            <span v-if="header.type == 'pageLink'">
                              {{ `pages/${item.id}/` }}
                            </span>
                          </td>
                          <td v-if="header.type == 'setting'" :key="index + 20">
                            <b-button
                              class="tableButtons"
                              v-if="header.edit == true"
                              variant="primary"
                              @click="showEditModal1(item)"
                              >ویرایش</b-button
                            >
                            <b-button
                              class="tableButtons"
                              v-if="header.delete == true"
                              variant="danger"
                              @click="deleteItem1(item.id)"
                              >حذف</b-button
                            >
                          </td>
                        </template>
                      </tr>
                    </template>
                  </table>
                </div>
              </template>
              <!-- /.card-header -->

              <!-- /.card-body -->
              <!-- <div class="card-footer">
                <b-button variant="warning"
                 @click="showDraggableTable()"
                >
الویت بندی
                </b-button>
              </div> -->
            </div>
            <!-- /.card -->
          </div>
        </div>
        <div class="d-flex justify-content-center" v-if="!status">
          <pagination
            v-if="fullData != null"
            :data="fullData"
            @pagination-change-page="changePage"
            :disabled="status"
          ></pagination>
        </div>
      </div>
    </section>
    <Loading :show_loading="status" />
    <b-modal
      ref="postModal"
      hide-footer
      v-model="showPostModal"
      @hidden="resetModal1"
      id="postModal"
      :title="mode == 'create' ? 'افزودن صفحه ' : ' ویرایش صفحه '"
    >
      <b-form class="SForm" @submit.prevent="submitForm">
        <b-form-group label="عنوان صفحه" class="col-12">
          <b-form-input
            ref="title"
            :value="edit_item == null ? '' : edit_item.title"
            name="title"
            placeholder="عنوان صفحه را وارد کنید"
          ></b-form-input>
        </b-form-group>
        <b-form-group label=" محتوا" class="col-12">
          <ckeditor
            :editor="editor"
            v-model="editorData"
            :config="editorConfig"
          ></ckeditor>
        </b-form-group>
        <b-form-group label=" وضعیت" class="col-12">
          <b-form-checkbox switch v-model="status">
            نمایش
          </b-form-checkbox>
        </b-form-group>

        <!-- در صورت زیاد بودن تعداد فیلد ها دو ستون تشکیل بده -->

        <div class="form_btn col-12">
          <b-button
            :class="{ disbledLink: disabled == true }"
            type="submit"
            variant="primary"
            >{{ mode == "create" ? "ارسال" : "ویرایش" }}</b-button
          >
        </div>
      </b-form>
      <!-- /.card-body -->
    </b-modal>

    <!-- /.content -->
  </div>
</template>
<script>
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import "@ckeditor/ckeditor5-build-classic/build/translations/fa";
import Loading from "@/components/admin/loading.vue";
import mixin from "../../mixins/mixins";
import {
  BFormInput,
  BFormCheckbox,
  BFormGroup,
  BForm,
  BModal,
  BButton
} from "bootstrap-vue";
export default {
  metaInfo() {
    return {
      title: "صفحات"
    };
  },
  components: {
    Loading,
    BFormCheckbox,
    BFormGroup,
    BFormInput,
    BForm,
    BModal,
    BButton
  },
  mixins: [mixin],
  data() {
    return {
      editor: ClassicEditor,
      editorData: "<p>محتوا را وارد کنید</p>",
      editorConfig: {
        language: "fa"
      },
      status: false,
      searchName: null,
      routeKey: "pages",
      showPostModal: false,
      headers: [
        {
          style: "col-12",
          show_in_tabel: true,
          placeholder: "عنوان صفحه",
          type: "string",
          name: "عنوان",
          key: "title"
        },

        {
          style: "col-12",
          show_in_tabel: false,
          placeholder: "",
          type: "ckEditor",
          name: "محتوا",
          key: "text"
        },

        {
          style: "col-12",
          show_in_tabel: true,
          placeholder: "",
          type: "pageLink",
          name: "آدرس",
          key: "pageLink"
        },
        {
          style: "col-12",
          show_in_tabel: true,
          placeholder: "نمایش",
          type: "boolean",
          name: "وضعیت",
          key: "status"
        },

        {
          style: "col-12",
          show_in_tabel: true,
          placeholder: "",
          type: "setting",
          name: "تنظیمات",
          key: "",
          edit: true,
          delete: true
        }
      ],
      mode: "create",
      edit_item: null,
      current_url: "/admin/pages"
    };
  },
  created() {
    if (this.Items == null) {
      this.getItemsFromServer(
        this.current_url,
        this.$route.query.page != undefined ? this.$route.query.page : "1",
        false,
        "",
        this.routeKey
      );
    }
  },
  methods: {
    resetModal1() {
      this.editorData = null;
      this.status = false;
      this.mode = "create";
      this.edit_item = null;
    },
    deleteItem1(id) {
      window
        .swal({
          title: "آیتم حذف شود؟",
          text: "این عمل بازگشت پذیر نیست",
          icon: "warning",

          showCancelButton: true,
          showConfirmButton: true,
          dangerMode: true,
          buttons: ["خیر", "یله"]
        })
        .then((willDelete) => {
          if (willDelete) {
            this.$axios
              .delete(this.current_url + `/${id}`)
              .then((response) => {
                window.swal({
                  icon: "success",
                  showConfirmButton: true,
                  text: response.data.message,
                  button: "OK"
                });
                this.Items = this.Items.filter((item) => item.id != id);
              })
              .catch((error) => {
                window.swal({
                  title: "خطا",
                  showConfirmButton: true,
                  text: error.response.data.message,
                  button: "OK"
                });
              });
          }
        })
        .catch(() => {});
    },
    showEditModal1(item) {
      this.edit_item = item;
      this.editorData = item.text;
      this.mode = "edit";
      this.status = Boolean(item.status);
      this.showPostModal = true;
    },
    submitForm(e) {
      let form_data = new FormData(e.target);
      form_data.append("text", this.editorData);
      form_data.append("status", this.status == true ? 1 : 0);
      form_data.append("_method", this.mode == "edit" ? "put" : "post");
      this.$axios
        .post(
          this.current_url +
            (this.mode == "edit" ? `/${this.edit_item.id}` : ""),
          form_data
        )
        .then((response) => {
          this.disabled = false;
          this.getItemsFromServer(
            this.current_url,
            1,
            false,
            "",
            this.routeKey,
            this.urlParams != undefined ? this.urlParams : ""
          );
          this.mode = "create";
          this.$root.notify(response.data.message, "success");
          this.showPostModal = false;
          this.edit_item = null;
        })
        .catch((error) => {
          this.disabled = false;
          this.$root.notify(error);
        });
    },
    showPostModal1() {
      this.mode = "create";
      // this.$bvModal.show("postModal");
      this.showPostModal = true;
    }
  },
  watch: {
    searchName(newVal) {
      if (newVal == null || newVal == "" || newVal == " ") {
        this.$router.replace({ name: "pages", query: { page: "1" } });
      } else {
        this.getItemsFromServer(
          this.current_url,
          1,
          true,
          `&searchBy1=name&search1=${newVal}`,
          this.routeKey
        );
      }
    }
  }
};
</script>
